import RightArrow from "components/RightArrow";
import SectionHeader from "components/SectionHeader";
import { RecentVend } from "./models";
import { currencyLabel, shortDate, unit } from "helpers";
import { Link } from "react-router-dom";

interface LastVendProps {
    vends?: RecentVend[];
}

export default function LastVends({ vends }: LastVendProps) {
    const hasPreviousVends = !!vends && vends.length > 0;

    return (
        <div>
            <SectionHeader>Last few vends</SectionHeader>
            {hasPreviousVends ? (
                <ul className="space-y-2">
                    {vends!.map((vend) => (
                        <li key={vend.id}>
                            <Link
                                to={`/vends/${vend.id}`}
                                className={`flex items-center gap-3 rounded-lg border px-3 py-3 active:bg-gray-50 ${
                                    vend.collectionsAmount > 0
                                        ? "border-amber-200 bg-amber-50/70"
                                        : "border-gray-200 bg-white"
                                }`}
                            >
                                <div className="min-w-0 flex-1">
                                    <div className="text-xs text-gray-500">{shortDate(vend.vendDate)}</div>
                                    <div className="mt-0.5 text-sm font-medium text-gray-800">
                                        {vend.units}{unit(vend.productUnit)}
                                    </div>
                                </div>

                                <div className="shrink-0 text-right">
                                    <div className="text-sm font-semibold text-gray-800">
                                        {currencyLabel(vend.tendered)}
                                    </div>
                                    {vend.collectionsAmount > 0 && (
                                        <div className="mt-1 text-xs font-medium text-amber-900">
                                            incl. {currencyLabel(vend.collectionsAmount)} coll.
                                        </div>
                                    )}
                                </div>

                                <RightArrow />
                            </Link>
                        </li>
                    ))}
                </ul>
            ) : (
                <div className="my-4 text-gray-500 font-bold text-sm">No previous vends</div>
            )}
        </div>
    );
}
